<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPause_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <path
        fill="currentColor"
        fill-rule="evenodd"
        d="M4.79 1A1.79 1.79 0 0 0 3 2.79v10.42a1.79 1.79 0 1 0 3.581 0V2.79A1.79 1.79 0 0 0 4.791 1Zm7.163 0a1.79 1.79 0 0 0-1.79 1.79v10.42a1.79 1.79 0 1 0 3.581 0V2.79A1.79 1.79 0 0 0 11.954 1Z"
        clip-rule="evenodd"
    />
</svg>
